import { Pipe, PipeTransform } from '@angular/core';
import {
  KYMW7002NewUnitType,
  NewUnitTypeList,
} from '../kymw7002.model';

@Pipe({
  name: 'newUnitType'
})
export class NewUnitTypePipe implements PipeTransform {

  transform(value: KYMW7002NewUnitType): string {
    let label = String(value);

    for (const newUnitType of NewUnitTypeList) {
      if (newUnitType.value === value) {
        label = newUnitType.label;
      }
    }

    return label;
  }

}
